/**
 * SEO Configuration for MARISSA GOLD AND DIAMONDS
 * Comprehensive SEO targeting all Indian cities and jewelry keywords
 */

// Business Information
export const BUSINESS_INFO = {
  name: 'Marissa Gold and Diamonds',
  phone: '+91 8885559409',
  email: 'support@marissa.in',
  description: 'Premium gold, silver, diamond and platinum jewelry store in India. Shop exquisite handcrafted ornaments for weddings, festivals and special occasions.',
  foundingDate: '2020',
  priceRange: '₹₹₹',
  currency: 'INR',
  logo: process.env.REACT_APP_DEFAULT_LOGO || `${process.env.REACT_APP_BACKEND_URL}/api/uploads/marissa_logo.png`,
};

// All Indian Cities for Local SEO
export const INDIAN_CITIES = {
  metro: [
    'Mumbai', 'Delhi', 'Bangalore', 'Bengaluru', 'Hyderabad', 'Chennai', 
    'Kolkata', 'Pune', 'Ahmedabad'
  ],
  tier2: [
    'Jaipur', 'Lucknow', 'Kanpur', 'Nagpur', 'Indore', 'Thane', 'Bhopal',
    'Visakhapatnam', 'Patna', 'Vadodara', 'Ghaziabad', 'Ludhiana', 'Agra',
    'Nashik', 'Faridabad', 'Meerut', 'Rajkot', 'Varanasi', 'Srinagar',
    'Aurangabad', 'Dhanbad', 'Amritsar', 'Allahabad', 'Ranchi', 'Howrah',
    'Coimbatore', 'Jabalpur', 'Gwalior', 'Vijayawada', 'Jodhpur', 'Madurai',
    'Raipur', 'Kota', 'Chandigarh', 'Guwahati', 'Solapur', 'Hubli', 'Mysore',
    'Tiruchirappalli', 'Bareilly', 'Aligarh', 'Tiruppur', 'Moradabad', 'Jalandhar',
    'Bhubaneswar', 'Salem', 'Warangal', 'Guntur', 'Bhiwandi', 'Saharanpur',
    'Gorakhpur', 'Bikaner', 'Amravati', 'Noida', 'Jamshedpur', 'Bhilai',
    'Cuttack', 'Firozabad', 'Kochi', 'Nellore', 'Bhavnagar', 'Dehradun',
    'Durgapur', 'Asansol', 'Rourkela', 'Nanded', 'Kolhapur', 'Ajmer',
    'Akola', 'Gulbarga', 'Jamnagar', 'Ujjain', 'Loni', 'Siliguri',
    'Jhansi', 'Ulhasnagar', 'Jammu', 'Sangli', 'Mangalore', 'Erode',
    'Belgaum', 'Ambattur', 'Tirunelveli', 'Malegaon', 'Gaya', 'Udaipur',
    'Kakinada', 'Davanagere', 'Kozhikode', 'Maheshtala', 'Rajpur Sonarpur',
    'Rajahmundry', 'Bokaro', 'South Dumdum', 'Bellary', 'Patiala',
    'Gopalpur', 'Agartala', 'Bhagalpur', 'Muzaffarnagar', 'Bhatpara',
    'Panihati', 'Latur', 'Dhule', 'Rohtak', 'Korba', 'Bhilwara',
    'Brahmapur', 'Muzaffarpur', 'Ahmednagar', 'Mathura', 'Kollam',
    'Avadi', 'Kadapa', 'Kamarhati', 'Sambalpur', 'Bilaspur', 'Shahjahanpur',
    'Satara', 'Bijapur', 'Rampur', 'Shivamogga', 'Chandrapur', 'Junagadh',
    'Thrissur', 'Alwar', 'Bardhaman', 'Kulti', 'Nizamabad', 'Parbhani',
    'Tumkur', 'Khammam', 'Ozhukarai', 'Bihar Sharif', 'Panipat', 'Darbhanga',
    'Bally', 'Aizawl', 'Dewas', 'Ichalkaranji', 'Karnal', 'Bathinda',
    'Jalna', 'Eluru', 'Barasat', 'Kirari Suleman Nagar', 'Purnia'
  ],
  tier3: [
    'Imphal', 'Shillong', 'Aizawl', 'Kohima', 'Itanagar', 'Gangtok',
    'Silvassa', 'Daman', 'Diu', 'Kavaratti', 'Port Blair', 'Pondicherry',
    'Shimla', 'Dharamshala', 'Manali', 'Ooty', 'Munnar', 'Kodaikanal',
    'Mount Abu', 'Nainital', 'Mussoorie', 'Darjeeling', 'Gangtok',
    'Shillong', 'Tawang', 'Kaziranga', 'Hampi', 'Khajuraho', 'Ajanta',
    'Ellora', 'Bodh Gaya', 'Rishikesh', 'Haridwar', 'Pushkar', 'Rameswaram',
    'Kanyakumari', 'Madurai', 'Thanjavur', 'Mahabalipuram', 'Puri',
    'Konark', 'Dwarka', 'Somnath', 'Tirupati', 'Shirdi', 'Vaishno Devi'
  ]
};

// Get all cities as flat array
export const getAllCities = () => [
  ...INDIAN_CITIES.metro,
  ...INDIAN_CITIES.tier2,
  ...INDIAN_CITIES.tier3
];

// Jewelry Keywords
export const JEWELRY_KEYWORDS = {
  products: [
    'gold jewelry', 'silver jewelry', 'diamond jewelry', 'platinum jewelry',
    'gold ornaments', 'silver ornaments', 'diamond ornaments',
    'gold jewellery', 'silver jewellery', 'diamond jewellery',
    'gold necklace', 'gold chain', 'gold bangles', 'gold earrings', 'gold ring',
    'silver necklace', 'silver chain', 'silver bangles', 'silver earrings', 'silver ring',
    'diamond necklace', 'diamond ring', 'diamond earrings', 'diamond pendant',
    'mangalsutra', 'bridal jewelry', 'wedding jewelry', 'engagement ring',
    'solitaire ring', 'tennis bracelet', 'charm bracelet', 'anklet', 'nose pin',
    'gold pendant', 'diamond pendant', 'pearl jewelry', 'gemstone jewelry',
    'antique jewelry', 'traditional jewelry', 'modern jewelry', 'designer jewelry',
    'handcrafted jewelry', 'custom jewelry', 'personalized jewelry'
  ],
  occasions: [
    'wedding jewelry', 'bridal jewelry', 'engagement jewelry',
    'anniversary gifts', 'birthday gifts', 'festival jewelry',
    'Diwali jewelry', 'Dussehra jewelry', 'Akshaya Tritiya jewelry',
    'Dhanteras gold', 'Karwa Chauth gifts', 'Raksha Bandhan gifts',
    'Valentine gifts', 'Mother\'s Day gifts', 'party wear jewelry',
    'office wear jewelry', 'daily wear jewelry', 'casual jewelry'
  ],
  materials: [
    '22k gold', '18k gold', '14k gold', '24k gold',
    '925 silver', 'sterling silver', 'pure silver',
    'VVS diamond', 'VS diamond', 'certified diamond', 'natural diamond',
    '950 platinum', '900 platinum', 'hallmarked gold', 'BIS hallmark',
    'IGI certified', 'GIA certified'
  ],
  styles: [
    'traditional Indian jewelry', 'South Indian jewelry', 'North Indian jewelry',
    'Kundan jewelry', 'Polki jewelry', 'Meenakari jewelry', 'Temple jewelry',
    'Navratna jewelry', 'Jadau jewelry', 'Thewa jewelry', 'Filigree jewelry',
    'contemporary jewelry', 'minimalist jewelry', 'statement jewelry',
    'layered necklace', 'choker necklace', 'long chain', 'haram'
  ],
  buying: [
    'buy gold online', 'buy silver online', 'buy diamond online',
    'gold jewelry online India', 'silver jewelry online India',
    'best gold jewelry store', 'trusted jewelry store',
    'jewelry store near me', 'gold shop near me',
    'affordable gold jewelry', 'premium jewelry', 'luxury jewelry',
    'jewelry EMI', 'gold loan', 'jewelry exchange'
  ]
};

// Get all keywords as flat array
export const getAllKeywords = () => [
  ...JEWELRY_KEYWORDS.products,
  ...JEWELRY_KEYWORDS.occasions,
  ...JEWELRY_KEYWORDS.materials,
  ...JEWELRY_KEYWORDS.styles,
  ...JEWELRY_KEYWORDS.buying
];

// Generate city-specific keywords
export const getCityKeywords = (city) => [
  `gold jewelry in ${city}`,
  `silver jewelry in ${city}`,
  `diamond jewelry in ${city}`,
  `jewelry store in ${city}`,
  `gold shop in ${city}`,
  `best jewelers in ${city}`,
  `buy gold in ${city}`,
  `wedding jewelry ${city}`,
  `bridal jewelry ${city}`
];

// SEO for different page types
export const PAGE_SEO = {
  home: {
    title: 'Marissa Gold and Diamonds | Premium Gold, Silver & Diamond Jewelry in India',
    description: 'Shop exquisite gold, silver, diamond & platinum jewelry online. Hallmarked & certified ornaments for weddings, festivals & special occasions. Free shipping across India. EMI available.',
    keywords: [
      'gold jewelry India', 'silver jewelry online', 'diamond jewelry store',
      'buy gold online India', 'hallmarked gold jewelry', 'certified diamond jewelry',
      'wedding jewelry India', 'bridal jewelry online', 'premium jewelry store',
      ...INDIAN_CITIES.metro.map(city => `jewelry store ${city}`),
      ...INDIAN_CITIES.tier2.slice(0, 30).map(city => `gold jewelry ${city}`),
      ...INDIAN_CITIES.tier3.slice(0, 20).map(city => `jewelry shop ${city}`)
    ].join(', ')
  },
  products: {
    title: 'Shop Jewelry Collection | Gold, Silver, Diamond & Platinum | Marissa Gold',
    description: 'Explore our exclusive collection of gold, silver, diamond and platinum jewelry. Necklaces, rings, bangles, earrings & more. Hallmarked quality with best prices.',
    keywords: [
      'gold necklace', 'gold bangles', 'gold earrings', 'gold ring',
      'silver jewelry', 'diamond ring', 'platinum jewelry',
      'buy jewelry online', 'jewelry collection India'
    ].join(', ')
  },
  gold: {
    title: 'Gold Jewelry Collection | 22K & 18K Hallmarked Gold | Marissa Gold',
    description: 'Premium 22K & 18K hallmarked gold jewelry collection. Necklaces, chains, bangles, earrings, rings & pendants. BIS certified. Best gold rate. Shop now!',
    keywords: [
      '22k gold jewelry', '18k gold jewelry', 'hallmarked gold',
      'gold necklace', 'gold chain', 'gold bangles', 'gold earrings',
      'gold ring', 'gold pendant', 'buy gold jewelry online India',
      ...INDIAN_CITIES.tier2.slice(0, 20).map(city => `gold jewelry in ${city}`)
    ].join(', ')
  },
  silver: {
    title: 'Silver Jewelry Collection | 925 Sterling Silver | Marissa Gold',
    description: 'Elegant 925 sterling silver jewelry collection. Necklaces, rings, bracelets, earrings & anklets. Pure silver at best prices. Shop silver jewelry online.',
    keywords: [
      '925 silver jewelry', 'sterling silver', 'silver necklace',
      'silver ring', 'silver bracelet', 'silver earrings', 'silver anklet',
      'buy silver jewelry online India', 'pure silver jewelry',
      ...INDIAN_CITIES.tier2.slice(0, 15).map(city => `silver jewelry ${city}`)
    ].join(', ')
  },
  diamond: {
    title: 'Diamond Jewelry Collection | Certified Diamonds | Marissa Gold',
    description: 'Certified diamond jewelry collection. Solitaire rings, diamond necklaces, earrings & pendants. IGI & GIA certified. VVS, VS quality diamonds.',
    keywords: [
      'certified diamond jewelry', 'diamond ring', 'solitaire ring',
      'diamond necklace', 'diamond earrings', 'diamond pendant',
      'VVS diamond', 'IGI certified diamond', 'buy diamond jewelry India',
      ...INDIAN_CITIES.metro.map(city => `diamond jewelry ${city}`)
    ].join(', ')
  },
  platinum: {
    title: 'Platinum Jewelry Collection | Premium Platinum Ornaments | Marissa Gold',
    description: 'Exclusive platinum jewelry collection. Rings, chains, bracelets & pendants in pure platinum. Premium quality. Perfect for special occasions.',
    keywords: [
      'platinum jewelry', 'platinum ring', 'platinum chain',
      'platinum bracelet', 'platinum pendant', 'buy platinum jewelry India'
    ].join(', ')
  },
  marketAnalysis: {
    title: 'Gold & Silver Price Predictions | AI Market Analysis | Marissa Gold',
    description: 'AI-powered gold and silver market analysis. Get price predictions, investment recommendations, and market insights. Updated daily for Indian precious metals market.',
    keywords: [
      'gold price prediction India', 'silver price forecast', 'gold rate today',
      'silver rate today', 'gold market analysis', 'precious metals investment',
      'gold price forecast 2025', 'silver price prediction', 'buy gold timing',
      'best time to buy gold India', 'gold rate prediction tomorrow',
      ...INDIAN_CITIES.metro.map(city => `gold rate ${city}`),
      ...INDIAN_CITIES.tier2.slice(0, 20).map(city => `gold price ${city}`)
    ].join(', ')
  }
};

// Generate product-specific SEO
export const getProductSEO = (product) => {
  const category = product.category || 'jewelry';
  const metalType = product.metal_type || 'gold';
  const name = product.name || 'Jewelry';
  const weight = product.weight || '';
  const price = product.price || '';
  
  return {
    title: `${name} | ${metalType.charAt(0).toUpperCase() + metalType.slice(1)} ${category.charAt(0).toUpperCase() + category.slice(1)} | Marissa Gold`,
    description: `Buy ${name} online. Premium ${metalType} ${category} ${weight ? `weighing ${weight}g` : ''}. Hallmarked & certified. Free shipping across India. Easy returns. EMI available.`,
    keywords: [
      name.toLowerCase(),
      `${metalType} ${category}`,
      `buy ${metalType} ${category}`,
      `${metalType} ${category} online`,
      `${metalType} ${category} India`,
      `${category} for women`,
      `${category} for men`,
      'hallmarked jewelry',
      'certified jewelry',
      'buy jewelry online'
    ].join(', ')
  };
};

// Generate category-specific SEO
export const getCategorySEO = (category) => {
  const categoryName = category.charAt(0).toUpperCase() + category.slice(1);
  
  return {
    title: `${categoryName} Jewelry Collection | Gold, Silver & Diamond ${categoryName} | Marissa Gold`,
    description: `Shop beautiful ${category} jewelry online. Gold, silver, diamond & platinum ${category} collection. Traditional & modern designs. Hallmarked quality. Free shipping India.`,
    keywords: [
      `${category} jewelry`,
      `gold ${category}`,
      `silver ${category}`,
      `diamond ${category}`,
      `buy ${category} online`,
      `${category} for women`,
      `${category} designs`,
      `latest ${category}`,
      `traditional ${category}`,
      `modern ${category}`
    ].join(', ')
  };
};

// Structured Data Templates
export const getOrganizationSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": BUSINESS_INFO.name,
  "url": typeof window !== 'undefined' ? window.location.origin : '',
  "logo": BUSINESS_INFO.logo,
  "description": BUSINESS_INFO.description,
  "telephone": BUSINESS_INFO.phone,
  "email": BUSINESS_INFO.email,
  "foundingDate": BUSINESS_INFO.foundingDate,
  "sameAs": [],
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": BUSINESS_INFO.phone,
    "contactType": "customer service",
    "availableLanguage": ["English", "Hindi"]
  }
});

export const getLocalBusinessSchema = () => ({
  "@context": "https://schema.org",
  "@type": "JewelryStore",
  "name": BUSINESS_INFO.name,
  "image": BUSINESS_INFO.logo,
  "telephone": BUSINESS_INFO.phone,
  "email": BUSINESS_INFO.email,
  "priceRange": BUSINESS_INFO.priceRange,
  "currenciesAccepted": BUSINESS_INFO.currency,
  "paymentAccepted": "Cash, Credit Card, Debit Card, UPI, Net Banking, EMI",
  "areaServed": {
    "@type": "Country",
    "name": "India"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Jewelry Collection",
    "itemListElement": [
      { "@type": "OfferCatalog", "name": "Gold Jewelry" },
      { "@type": "OfferCatalog", "name": "Silver Jewelry" },
      { "@type": "OfferCatalog", "name": "Diamond Jewelry" },
      { "@type": "OfferCatalog", "name": "Platinum Jewelry" }
    ]
  }
});

export const getProductSchema = (product, url) => ({
  "@context": "https://schema.org",
  "@type": "Product",
  "name": product.name,
  "image": product.images?.[0] || '',
  "description": product.description || `Premium ${product.metal_type} ${product.category} from Marissa Gold and Diamonds`,
  "sku": product.id,
  "brand": {
    "@type": "Brand",
    "name": BUSINESS_INFO.name
  },
  "offers": {
    "@type": "Offer",
    "url": url,
    "priceCurrency": "INR",
    "price": product.total_price || product.base_price || 0,
    "availability": product.is_sold_out ? "https://schema.org/OutOfStock" : "https://schema.org/InStock",
    "seller": {
      "@type": "Organization",
      "name": BUSINESS_INFO.name
    }
  },
  "aggregateRating": product.average_rating ? {
    "@type": "AggregateRating",
    "ratingValue": product.average_rating,
    "reviewCount": product.review_count || 1
  } : undefined,
  "material": product.metal_type,
  "weight": product.weight ? `${product.weight} grams` : undefined
});

export const getBreadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": items.map((item, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": item.name,
    "item": item.url
  }))
});

export const getWebsiteSchema = () => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": BUSINESS_INFO.name,
  "url": typeof window !== 'undefined' ? window.location.origin : '',
  "potentialAction": {
    "@type": "SearchAction",
    "target": {
      "@type": "EntryPoint",
      "urlTemplate": `${typeof window !== 'undefined' ? window.location.origin : ''}/products?search={search_term_string}`
    },
    "query-input": "required name=search_term_string"
  }
});
